import { useCallback, useState } from 'react';
import { Box, PasswordField, Button, TextField, Alert } from '@doist/reactist';

import Spinner from '../../components/Spinner';

import '@doist/reactist/styles/alert.css';
import { logUserIn } from '../../hooks/useUsers';

function Login() {
    const [ email, setEmail ] = useState('');
    const [ password, setPassword ] = useState('');
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState(false);

    const preformLogin = useCallback(() => {
        setLoading(true);
        logUserIn({ email, password }, (err) => {
            if (err) {
                setError(true);
                setLoading(false);
            }
        });
    }, [ email, password, setLoading ]);

    if (loading) {
        return <Spinner />
    }
    
    return (
        <Box display="block" padding="xxlarge" minWidth="small" style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', border: '1px solid #ccc', boxShadow: "5px 5px 16px 0px rgba(0,0,0,0.29)" }}>
            <form onSubmit={(evt) => {evt.preventDefault();preformLogin();}}>
                {error && <><Alert tone="critical">Login Error</Alert><br /></>}
                <TextField
                    label="Email Address"
                    maxWidth="small"
                    message=""
                    placeholder="Enter your email"
                    tone="neutral"
                    variant="default"
                    value={email}
                    onChange={(evt) => { setEmail(evt.target.value); }}
                    /><br />
                <PasswordField
                    label="Password"
                    maxWidth="small"
                    message=""
                    placeholder="Enter your password"
                    value={password}
                    onChange={(evt) => { setPassword(evt.target.value); }}
                /><br />
                <Button type='submit' variant="primary">Login</Button>
            </form>
        </Box>
    );
};

export default Login;
